module.exports = __webpack_public_path__ + "static/media/capsule_machine_en_ori_2.f67c63ab.png";